// Module
var code = "<h3>Enlightenment Questions - Question From Peter</h3> <p>Dear Tathagata </p> <p>What is the best and quickest way to make good karma and to rid myself of bad karma. </p> <p>What can I do, seeing that there is little time left. </p> <p>Peter</p> <p>Answer From Tathagata</p> <p>&quot;Awake yourself&quot;.</p> ";
// Exports
module.exports = code;